module.exports = __webpack_public_path__ + "img/bg2.ffdc29b3.png";